//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { DaySelectionDisplayItem } from './DaySelectionDisplayItem';
import { AvailabilityLocationItem } from './AvailabilityLocationItem';

export class TeacherAvailabilityInputItem extends ItemBase {
    DaySelection: DaySelectionDisplayItem | null = null;
    EndDate: string | null = null;
    EndTimeInMinutes: number = 0;
    Notes: string | null = null;
    StartDate: string | null = null;
    StartTimeInMinutes: number = 0;
    TeacherID: string | null = null;
    Locations: AvailabilityLocationItem[] = [];
    AllowOnlineBooking: boolean = false;

    constructor(initializer?: Partial<TeacherAvailabilityInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherAvailabilityInputItem";
}
